import {
  Box,
  Divider,
  Drawer,
  InputAdornment,
  ListSubheader,
  MenuItem,
  Typography,
} from "@mui/material";
import { X } from "lucide-react";
import React, { useCallback, useEffect, useState } from "react";
import { useTheme } from "../../../style/theme";
import { IoFilterOutline, IoSettingsOutline } from "react-icons/io5";
import { CiExport, CiImport } from "react-icons/ci";
import { MdEdit, MdOutlineRemoveRedEye } from "react-icons/md";
import { IoIosMore, IoMdInformationCircleOutline } from "react-icons/io";
import { LuCalendarDays } from "react-icons/lu";
import { IoCloseSharp } from "react-icons/io5";
import * as XLSX from "xlsx";

import {
  format,
  startOfMonth,
  endOfMonth,
  subMonths,
  subDays,
  startOfYear,
  endOfYear,
  subYears,
} from "date-fns";

import Select from "react-select";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
} from "@mui/material";
import { Radio, RadioGroup, FormControlLabel, TextField } from "@mui/material";
import { Close } from "@mui/icons-material";
import { CgClose } from "react-icons/cg";
import SearchIcon from "@mui/icons-material/Search";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Button,
} from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";
import { Controller, useForm } from "react-hook-form";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import EditIcon from "@mui/icons-material/Edit";
import ExportModal from "../../../components/ExportModal";
import { useMessage } from "../../../components/Header";
import ImportModal from "../../../components/ImportModal";
import ApplyLeaveModal from "../../../components/ApplyLeaveModal";
import NocompensatoryRequest from "../../DashComponents/Nocompensatory";

export default function TeamCompensatoryRequest() {
  const { mode } = useTheme();
  const [openFilterDrawer, setOpenFilterDrawer] = useState(false);
  const [filter, setFilter] = useState("This Year");
  const [isOpen, setIsOpen] = useState(false);
  const [recordsPerPage, setRecordsPerPage] = useState(20);
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [view, setView] = useState("direct");
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteModal, setDeleteModal] = useState();
  const [selectedIds, setSelectedIds] = useState([]);
  const [editData, setEditData] = useState(null);
  const [viewData, setViewData] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [isCancelling, setIsCancelling] = useState(false);
  const [filteredRequests, setFilteredRequests] = useState([]);
  const [exportOpen, setExportOpen] = useState(false);
  const [openImportModal, setOpenImportModal] = useState(false);
  const { showSuccess, showError } = useMessage();
  const [selectedFile, setSelectedFile] = useState(null);
  const [openApply, setOpenApply] = useState(false);
  const [filterr, setFilterr] = useState(""); // Empty by default

  let currentOrg = JSON.parse(localStorage.getItem("org"));
  let currentemp = JSON.parse(localStorage.getItem("emp"));

  const handleCheckboxChange = (id, isChecked) => {
    if (isChecked) {
      setSelectedIds((prev) => [...prev, id]);
      setModalOpen(false);
    } else {
      setSelectedIds((prev) => prev.filter((item) => item !== id));
    }
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      const allIds = requests?.map((req) => req._id);
      setSelectedIds(allIds);
    } else {
      setSelectedIds([]);
    }
  };

  console.log(selectedIds, "selectedIdsselectedIds");

  const getDate = (isoDate) => {
    const date = isoDate?.split("T")[0];
    const normalDate = `${date?.split("-")[2]}-${date?.split("-")[1]}-${
      date?.split("-")[0]
    }`;
    return normalDate;
  };

  const handleClose = () => {
    setOpenImportModal(false);
    setSelectedFile(null);
  };

  const fetchRequests = async () => {
    try {
      if (currentOrg?.type === "Owner") {
        const response = await axios.get(
          `/hr/adminCompensatory?orgId=${currentOrg?._id}`
        );

        console.log(response.data.requests, "jjjj");
        setRequests(response.data.requests);
        setFilteredRequests(response.data.requests);
      } else {
        const response = await axios.get(`/hr/compensatory/${currentemp?._id}`);

        console.log(response.data.request, "jjjj");
        setRequests(response.data.request);
        setFilteredRequests(response.data.request);
      }
    } catch (error) {
      console.error("Error fetching requests:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  const handleCompensatoryImport = () => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(sheet);

      const payloads = [];
      let hasInvalidRow = false;

      jsonData?.forEach((row, index) => {
        const workedDate = row["Worked Date"];
        const expiryDate = row["Expiry Date"];
        const duration = row["Duration"];
        const unit = row["Unit"];
        const reason = row["Reason"];
        const submittedBy = row["Submitted By"];
        const workedTimeFrom = row["Worked Time From"] || row["From"];
        const workedTimeTo = row["Worked Time To"] || row["To"];

        if (
          !workedDate ||
          !expiryDate ||
          !duration ||
          (unit === "Hours" && (!workedTimeFrom || !workedTimeTo))
        ) {
          showError(`❌ Row ${index + 2}: Missing required fields.`);
          hasInvalidRow = true;
          return;
        }

        // Convert balance
        let balance = 0;
        if (unit === "Days") {
          const map = {
            "Full Day": 8,
            "Half Day": 4,
            "Quarter Day": 2,
          };
          balance = map[duration] || 0;
        } else if (unit === "Hours") {
          balance = parseFloat(duration || 0);
        }

        payloads.push({
          adminId: currentOrg?._id,
          adminName: currentOrg?.name,
          workedDate,
          workedTime: {
            from: workedTimeFrom || "-",
            to: workedTimeTo || "-",
          },
          unit,
          balance,
          duration,
          expiryDate,
          reason: reason || "",
        });
      });

      if (hasInvalidRow) return;

      payloads.forEach(async (payload) => {
        try {
          await axios.post("/hr/adminCompensatory", payload);
          showSuccess("File imported successfully!");
          fetchRequests(); // Refresh list
        } catch (err) {
          console.error("Upload failed for:", payload, err);
        }
      });

      handleClose(); // Close modal
    };

    if (selectedFile) {
      reader.readAsArrayBuffer(selectedFile);
    }
  };

  const FilterDrawer = ({ setFilterr, filterr }) => {
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [employeeSearch, setEmployeeSearch] = useState("");
    const [isCustomDate, setIsCustomDate] = useState(false);

    useEffect(() => {
      const today = new Date();
      let from = "";
      let to = "";

      switch (filter) {
        case "Today":
          from = to = today.toISOString().split("T")[0];
          break;

        case "Yesterday":
          const yest = new Date(today);
          yest.setDate(today.getDate() - 1);
          from = to = yest.toISOString().split("T")[0];
          break;

        case "This Month":
          from = new Date(today.getFullYear(), today.getMonth(), 1)
            .toISOString()
            .split("T")[0];
          to = new Date(today.getFullYear(), today.getMonth() + 1, 0)
            .toISOString()
            .split("T")[0];
          break;

        case "Last Month":
          from = new Date(today.getFullYear(), today.getMonth() - 1, 1)
            .toISOString()
            .split("T")[0];
          to = new Date(today.getFullYear(), today.getMonth(), 0)
            .toISOString()
            .split("T")[0];
          break;

        case "This Year":
          from = new Date(today.getFullYear(), 0, 1)
            .toISOString()
            .split("T")[0];
          to = new Date(today.getFullYear(), 11, 31)
            .toISOString()
            .split("T")[0];
          break;

        case "Last Year":
          from = new Date(today.getFullYear() - 1, 0, 1)
            .toISOString()
            .split("T")[0];
          to = new Date(today.getFullYear() - 1, 11, 31)
            .toISOString()
            .split("T")[0];
          break;

        case "Custom":
          setIsCustomDate(true);
          return;

        default:
          return;
      }

      setFromDate(from);
      setToDate(to);
      setIsCustomDate(false);
    }, [filter]);

    const applyFilters = () => {
      if (!filter) {
        toast.error("Please select a period first.");
        return;
      }

      if (filter === "Custom" && (!fromDate || !toDate)) {
        toast.error("Please select both From and To dates.");
        return;
      }

      let filtered = [...requests];

      if (fromDate && toDate) {
        const from = new Date(fromDate);
        const to = new Date(toDate);
        to.setHours(23, 59, 59, 999);

        filtered = filtered.filter((req) => {
          const created = new Date(req.createdAt);
          return created >= from && created <= to;
        });
      }

      setFilteredRequests(filtered);
      setOpenFilterDrawer(false);
    };

    const resetFilters = () => {
      setFromDate("");
      setToDate("");
      setEmployeeSearch("");
      setFilter("");
      setFilteredRequests(requests);
    };

    return (
      <Drawer
        anchor="right"
        open={openFilterDrawer}
        onClose={() => setOpenFilterDrawer(false)}
      >
        <div
          style={{ backgroundColor: mode === "light" ? "#fff" : "#141414" }}
          className="w-72 p-4"
        >
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-semibold">Filter</h2>
            <button
              onClick={() => setOpenFilterDrawer(false)}
              className="border-none outline-none"
            >
              <X size={20} />
            </button>
          </div>

          {/* Period Selection */}
          {/* Period Selection */}
          <label className="block text-sm font-medium mb-2 text-[#666666]">
            Period
          </label>
          <select
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className={`w-full text-sm rounded px-3 py-2 outline-none border ${
              mode === "light"
                ? "bg-white text-black border-gray-300"
                : "bg-[#1e1e1e] text-white border-gray-600"
            }`}
          >
            <option value="" disabled>
              Select...
            </option>
            <option value="Yesterday">Yesterday</option>
            <option value="Today">Today</option>
            <option value="This Month">This Month</option>
            <option value="This Year">This Year</option>
            <option value="Last Month">Last Month</option>
            <option value="Last Year">Last Year</option>
            <option value="Custom">Custom</option>
          </select>

          {/* From Date */}
          <div className="mt-4">
            <label className="block text-sm font-medium text-[#666666] mb-2">
              From
            </label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              disabled={!isCustomDate}
              className={`w-full text-sm border rounded px-3 py-1 bg-[#eeeef1] text-[#333] ${
                !isCustomDate ? "opacity-60 cursor-not-allowed" : ""
              }`}
            />
          </div>

          {/* To Date */}
          <div className="mt-4">
            <label className="block text-sm font-medium text-[#666666] mb-2">
              To
            </label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              disabled={!isCustomDate}
              className={`w-full text-sm border rounded px-3 py-1 bg-[#eeeef1] text-[#333] ${
                !isCustomDate ? "opacity-60 cursor-not-allowed" : ""
              }`}
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div
          style={{ backgroundColor: mode === "light" ? "#fff" : "#141414" }}
          className="flex items-end h-full pb-5 justify-start px-5 space-x-2"
        >
          <Button
            variant="contained"
            sx={{ backgroundColor: "#0088ff" }}
            onClick={applyFilters}
          >
            Apply
          </Button>
          <Button variant="outlined" onClick={resetFilters}>
            Reset
          </Button>
        </div>
      </Drawer>
    );
  };

  // const AddRequestDrawer = ({ editData }) => {
  //   const { handleSubmit, control, watch, setValue, reset } = useForm();
  //   const unit = watch("unit");
  //   const workedTimeFrom = watch("workedTimeFrom");
  //   const workedTimeTo = watch("workedTimeTo");

  //   const [nameOptions, setNameOptions] = useState([]);

  //   // Function to calculate duration
  //   const calculateDuration = () => {
  //     if (workedTimeFrom && workedTimeTo) {
  //       const fromTime = new Date(`1970-01-01T${workedTimeFrom}:00Z`);
  //       const toTime = new Date(`1970-01-01T${workedTimeTo}:00Z`);

  //       const diffInMs = toTime - fromTime; // Difference in milliseconds
  //       const hours = Math.floor(diffInMs / 1000 / 60 / 60); // Hours
  //       const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60)); // Minutes

  //       // Ensure both hours and minutes are two digits
  //       const durationString = `${hours < 10 ? "0" + hours : hours}:${
  //         minutes < 10 ? "0" + minutes : minutes
  //       }`;

  //       // Set the calculated duration in the correct format
  //       setValue("durationTime", durationString); // Automatically update duration field
  //     }
  //   };

  //   useEffect(() => {
  //     calculateDuration();
  //   }, [workedTimeFrom, workedTimeTo]);

  //   useEffect(() => {
  //     if (editData) {
  //       reset({
  //         workedDate: editData?.workedDate?.split("T")[0],
  //         unit: editData?.unit,
  //         duration:
  //           editData?.unit === "Days"
  //             ? { label: editData?.duration, value: editData?.duration }
  //             : "",
  //         durationTime: editData?.unit === "Hours" ? editData?.duration : "",
  //         workedTimeFrom: editData?.workedTime?.from,
  //         workedTimeTo: editData?.workedTime?.to,
  //         expiryDate: editData?.expiryDate?.split("T")[0],
  //         reason: editData?.reason,
  //       });
  //     } else {
  //       reset(); // 👈 Clear form on Add mode
  //     }
  //   }, [editData, reset]);
  //   console.log(editData, "editDataeditData");

  //   const onSubmit = async (data) => {
  //     let adminId = currentOrg?._id;
  //     let name = currentOrg?.name;
  //     try {
  //       const payload = {
  //         adminName: name,
  //         adminId: adminId,
  //         submittedBy: "Admin",
  //         workedDate: data?.workedDate,
  //         unit: data?.unit,
  //         balance:
  //           data?.unit === "Days"
  //             ? data?.duration?.value === "Full Day"
  //               ? 8
  //               : data?.duration?.value === "Half Day"
  //               ? 4
  //               : data?.duration?.value === "Quarter Day"
  //               ? 2
  //               : 0
  //             : data?.durationTime,
  //         duration:
  //           data?.unit === "Days" ? data?.duration?.value : data?.durationTime,
  //         workedTime:
  //           data?.unit === "Hours"
  //             ? { from: data?.workedTimeFrom, to: data?.workedTimeTo }
  //             : undefined,
  //         expiryDate: data?.expiryDate,
  //         reason: data?.reason,
  //       };

  //       if (editData) {
  //         // 👈 Update existing
  //         await axios.put(`/hr/adminCompensatory/${editData._id}`, payload);
  //         toast.success("Request updated successfully");
  //       } else {
  //         // 👈 Add new
  //         await axios.post("/hr/adminCompensatory", payload);
  //         toast.success("Request added successfully");
  //       }

  //       setDrawerOpen(false);
  //       setEditData(null);
  //       fetchRequests(); // 👈 Refresh list
  //     } catch (error) {
  //       console.error("Submit error:", error);
  //       toast.error("Failed to submit adminCompensatory request.");
  //     }
  //   };

  //   return (
  //     <Drawer
  //       anchor="right"
  //       open={isDrawerOpen}
  //       onClose={() => setDrawerOpen(false)}
  //       PaperProps={{
  //         className: "w-[99%] m-1 md:w-[650px] lg:w-[800px] rounded-lg",
  //       }}
  //     >
  //       <form
  //         onSubmit={handleSubmit(onSubmit)}
  //         className="h-full flex flex-col"
  //       >
  //         <div className="h-full bg-gray-200 flex flex-col relative">
  //           {/* Sticky Header */}
  //           <div
  //             className={`${
  //               mode === "light" ? "bg-[#edf0f4]" : "bg-[#141414]"
  //             }  px-4 py-2 flex justify-between items-center sticky top-0 z-10`}
  //           >
  //             <h2 className="text-[18px] font-semibold">Add Request</h2>
  //             <div
  //               className={`${
  //                 mode === "light" ? "bg-[#dcdcdc]" : ""
  //               } p-2 rounded-md cursor-pointer`}
  //               onClick={() => setDrawerOpen(false)}
  //             >
  //               <CgClose />
  //             </div>
  //           </div>

  //           <div
  //             className={`${
  //               mode === "light" ? "bg-[#edf0f4]" : "bg-[#141414]"
  //             } flex-1 overflow-y-auto p-4`}
  //           >
  //             <div
  //               style={{
  //                 backgroundColor: mode === "light" ? "#fff" : "#171717",
  //               }}
  //               className="px-5 py-4 rounded-md flex flex-col sm:flex-row  justify-between gap-5 "
  //             >
  //               <div className="w-full sm:w-[50%] lg:w-[400px]">
  //                 <div className="mb-4 w-full mt-2">
  //                   <div className="flex gap-2 items-center">
  //                     <label
  //                       className={`block text-[14px] font-[500] mb-2 mt-4`}
  //                     >
  //                       Worked date <span className="text-red-500">*</span>
  //                     </label>
  //                     <IoMdInformationCircleOutline />
  //                   </div>

  //                   <Controller
  //                     name="workedDate"
  //                     control={control}
  //                     render={({ field }) => (
  //                       <TextField
  //                         {...field}
  //                         type="date"
  //                         fullWidth
  //                         size="small"
  //                       />
  //                     )}
  //                   />
  //                 </div>

  //                 <div className="mb-4 w-full">
  //                   <label className={`block text-[14px] font-[500] mb-2 mt-4`}>
  //                     Unit <span className="text-red-500">*</span>
  //                   </label>
  //                   <Controller
  //                     name="unit"
  //                     control={control}
  //                     render={({ field }) => (
  //                       <RadioGroup row {...field}>
  //                         <FormControlLabel
  //                           value="Days" // ✅ Correct casing
  //                           control={<Radio />}
  //                           label="Days"
  //                         />
  //                         <FormControlLabel
  //                           value="Hours" // ✅ Correct casing
  //                           control={<Radio />}
  //                           label="Hours"
  //                         />
  //                       </RadioGroup>
  //                     )}
  //                   />
  //                 </div>

  //                 <div className="mb-4 w-full">
  //                   <label Duration={`block text-[14px] font-[500] mb-2 mt-4`}>
  //                     Duration <span className="text-red-500">*</span>
  //                   </label>
  //                   {unit === "Days" ? (
  //                     <Controller
  //                       name="duration"
  //                       control={control}
  //                       render={({ field }) => (
  //                         <Select
  //                           {...field}
  //                           options={[
  //                             { value: "Full Day", label: "Full Day" },
  //                             { value: "Half Day", label: "Half Day" },
  //                             { value: "Quarter Day", label: "Quarter Day" },
  //                           ]}
  //                           isClearable
  //                           styles={{
  //                             control: (provided) => ({
  //                               ...provided,
  //                               backgroundColor:
  //                                 mode === "light" ? "#fff" : "#141414",
  //                             }),
  //                             menu: (provided) => ({
  //                               ...provided,
  //                               backgroundColor:
  //                                 mode === "light" ? "#fff" : "#141414",
  //                             }),
  //                             option: (provided, state) => ({
  //                               ...provided,
  //                               backgroundColor: state.isFocused
  //                                 ? `#e0e0e0`
  //                                 : "#f0f0f0",
  //                               color: "#000",
  //                             }),
  //                           }}
  //                         />
  //                       )}
  //                     />
  //                   ) : (
  //                     <Controller
  //                       name="durationTime"
  //                       control={control}
  //                       render={({ field }) => (
  //                         <TextField
  //                           {...field}
  //                           type="text"
  //                           fullWidth
  //                           size="small"
  //                           // label="Duration (Calculated)"
  //                         />
  //                       )}
  //                     />
  //                   )}
  //                 </div>

  //                 <div className="mb-4">
  //                   <label>Worked Time (From - To)</label>
  //                   <div className="flex gap-2">
  //                     <Controller
  //                       name="workedTimeFrom"
  //                       control={control}
  //                       render={({ field }) => (
  //                         <TextField
  //                           {...field}
  //                           type="time"
  //                           fullWidth
  //                           size="small"
  //                         />
  //                       )}
  //                     />
  //                     <Controller
  //                       name="workedTimeTo"
  //                       control={control}
  //                       render={({ field }) => (
  //                         <TextField
  //                           {...field}
  //                           type="time"
  //                           fullWidth
  //                           size="small"
  //                         />
  //                       )}
  //                     />
  //                   </div>
  //                 </div>

  //                 <div className="mb-4 w-full">
  //                   <label Duration={`block text-[14px] font-[500] mb-2 mt-4`}>
  //                     Expiry date <span className="text-red-500">*</span>
  //                   </label>
  //                   <Controller
  //                     name="expiryDate"
  //                     control={control}
  //                     rules={{ required: true }}
  //                     render={({ field }) => (
  //                       <TextField
  //                         type="date"
  //                         fullWidth
  //                         size="small"
  //                         {...field}
  //                       />
  //                     )}
  //                   />
  //                 </div>

  //                 <div className="mb-4 w-full">
  //                   <label className="block text-[14px] font-[500] mb-2 mt-4">
  //                     Reason
  //                   </label>
  //                   <Controller
  //                     name="reason"
  //                     control={control}
  //                     render={({ field }) => (
  //                       <TextField fullWidth multiline rows={2} {...field} />
  //                     )}
  //                   />
  //                 </div>
  //               </div>

  //               {/* Fixed Attendance Details Box */}
  //               {/* <div
  //                 style={{
  //                   backgroundColor: mode === "light" ? "#FFF7E5" : "#191919",
  //                 }}
  //                 className="sm:fixed sm:right-[40px] sm:top-[70px] p-4 rounded md:w-[170px]"
  //               >
  //                 <h3 className="font-semibold text-[14px] text-[#ff832b] mb-2">
  //                   Attendance details
  //                 </h3>
  //                 <p className="flex gap-8 text-[13px] mt-4">
  //                   First in <span>-</span>
  //                 </p>
  //                 <p className="flex gap-8 text-[13px] mt-4">
  //                   Last out <span>-</span>
  //                 </p>
  //                 <p className="flex gap-8 text-[13px] mt-4">
  //                   Overtime <span>-</span>
  //                 </p>
  //                 <p className="flex gap-8 text-[13px] mt-4">
  //                   Total hours <span>-</span>
  //                 </p>
  //               </div> */}
  //               <div></div>
  //             </div>
  //           </div>

  //           {/* Sticky Footer */}
  //           <div
  //             className={`sticky flex gap-3 items-center top-0 ${
  //               mode === "light" ? "bg-[#edf0f4]" : "bg-[#141414]"
  //             }  z-10 py-4 px-4`}
  //           >
  //             <Button
  //               type="submit"
  //               variant="contained"
  //               sx={{ backgroundColor: "#0088ff" }}
  //             >
  //               {editData ? "Update" : "Submit"}
  //             </Button>

  //             <button
  //               style={{
  //                 backgroundColor: mode === "light" ? "#fff" : "#0088ff",
  //               }}
  //               className="w-[79px] h-[36px] rounded-md"
  //               onClick={() => setDrawerOpen(false)}
  //             >
  //               Cancel
  //             </button>
  //           </div>
  //         </div>
  //       </form>
  //     </Drawer>
  //   );
  // };

  const AddRequestDrawer = ({ editData, showSuccess, showError }) => {
    const {
      handleSubmit,
      control,
      watch,
      setValue,
      reset,
      formState: { errors },
    } = useForm();
    const unit = watch("unit");
    const workedTimeFrom = watch("workedTimeFrom");
    const workedTimeTo = watch("workedTimeTo");

    const [nameOptions, setNameOptions] = useState([]);

    const fetchEmployees = useCallback(async (employeeSearch = "") => {
      try {
        const response = await axios.get(
          `/hr/employee?pageSize=10${
            employeeSearch ? `&searchBy=firstName&search=${employeeSearch}` : ""
          }`
        );
        const employees = response.data.employees;
        const formatted = employees.map((emp) => ({
          value: emp._id,
          label: `${emp.firstName} ${emp.lastName}`,
        }));
        setNameOptions(formatted);
      } catch (e) {
        console.log(e);
      }
    }, []);

    useEffect(() => {
      fetchEmployees();
    }, [fetchEmployees]);

    const calculateDuration = () => {
      if (workedTimeFrom && workedTimeTo) {
        const fromTime = new Date(`1970-01-01T${workedTimeFrom}:00Z`);
        const toTime = new Date(`1970-01-01T${workedTimeTo}:00Z`);
        const diffInMs = toTime - fromTime;
        const hours = Math.floor(diffInMs / 1000 / 60 / 60);
        const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));
        const durationString = `${hours < 10 ? "0" + hours : hours}:${
          minutes < 10 ? "0" + minutes : minutes
        }`;
        setValue("durationTime", durationString);
      }
    };

    useEffect(() => {
      calculateDuration();
    }, [workedTimeFrom, workedTimeTo]);

    useEffect(() => {
      if (editData) {
        reset({
          employee: {
            value: editData?.employee?._id,
            label: `${editData?.employee?.firstName} ${editData?.employee?.lastName}`,
          },
          workedDate: editData?.workedDate?.split("T")[0],
          unit: editData?.unit,
          duration:
            editData?.unit === "Days"
              ? { label: editData?.duration, value: editData?.duration }
              : "",
          durationTime: editData?.unit === "Hours" ? editData?.duration : "",
          workedTimeFrom: editData?.workedTime?.from,
          workedTimeTo: editData?.workedTime?.to,
          expiryDate: editData?.expiryDate?.split("T")[0],
          reason: editData?.reason,
        });
      } else {
        reset();
      }
    }, [editData, reset]);

    const onSubmit = async (data) => {
      let adminId = currentOrg?._id;
      let name = currentOrg?.name;
      try {
        const payload = {
          adminName: name,
          adminId: adminId,
          submittedBy: "Admin",
          workedDate: data?.workedDate,
          unit: data?.unit,
          balance:
            data?.unit === "Days"
              ? data?.duration?.value === "Full Day"
                ? 8
                : data?.duration?.value === "Half Day"
                ? 4
                : data?.duration?.value === "Quarter Day"
                ? 2
                : 0
              : data?.durationTime,
          duration:
            data?.unit === "Days" ? data?.duration?.value : data?.durationTime,
          workedTime:
            data?.unit === "Hours"
              ? { from: data?.workedTimeFrom, to: data?.workedTimeTo }
              : undefined,
          expiryDate: data?.expiryDate,
          reason: data?.reason,
        };

        const payloadEmployee = {
          adminId,
          employee: currentemp?._id,
          userId: currentemp?._id,
          submittedBy: "Employee",
          workedDate: data?.workedDate,
          unit: data?.unit,
          balance:
            data?.unit === "Days"
              ? data?.duration?.value === "Full Day"
                ? 8
                : data?.duration?.value === "Half Day"
                ? 4
                : data?.duration?.value === "Quarter Day"
                ? 2
                : 0
              : data?.durationTime,
          duration:
            data?.unit === "Days" ? data?.duration?.value : data?.durationTime,
          workedTime:
            data?.unit === "Hours"
              ? { from: data?.workedTimeFrom, to: data?.workedTimeTo }
              : undefined,
          expiryDate: data?.expiryDate,
          reason: data?.reason,
          isAllowable: true,
        };

        try {
          const isOwner = currentOrg?.type === "Owner";

          if (editData) {
            // Update existing
            const url = isOwner
              ? `/hr/adminCompensatory/${editData._id}`
              : `/hr/compensatory/${editData._id}`;
            const data = isOwner ? payload : payloadEmployee;

            await axios.put(url, data);
            showSuccess("Request updated successfully");
          } else {
            // Add new
            const url = isOwner ? "/hr/adminCompensatory" : "/hr/compensatory";
            const data = isOwner ? payload : payloadEmployee;; // both use `payload` for POST

            await axios.post(url, data);
            showSuccess("Request added successfully");
          }
        } catch (error) {
          console.error(error);
          showError("Something went wrong. Please try again.");
        }

        setDrawerOpen(false);
        setEditData(null);
        fetchRequests(); // 👈 Refresh list
      } catch (error) {
        console.error("Submit error:", error);
        showError("Failed to submit adminCompensatory request.");
      }
    };

    return (
      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          className: "w-[99%] m-1 md:w-[650px] lg:w-[800px] rounded-lg",
        }}
      >
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="h-full flex flex-col"
        >
          <div className="h-full bg-gray-200 flex flex-col relative">
            {/* Sticky Header */}
            <div
              className={`${
                mode === "light" ? "bg-[#edf0f4]" : "bg-[#141414]"
              } px-4 py-2 flex justify-between items-center sticky top-0 z-10`}
            >
              <h2 className="text-[18px] font-semibold">
                {editData ? "Edit Request" : "Add Request"}
              </h2>
              <div
                className={`${
                  mode === "light" ? "bg-[#dcdcdc]" : ""
                } p-2 rounded-md cursor-pointer`}
                onClick={() => setDrawerOpen(false)}
              >
                <CgClose />
              </div>
            </div>

            {/* Form Fields */}
            <div
              className={`${
                mode === "light" ? "bg-[#edf0f4]" : "bg-[#141414]"
              } flex-1 overflow-y-auto p-4`}
            >
              <div
                style={{
                  backgroundColor: mode === "light" ? "#fff" : "#171717",
                }}
                className="px-5 py-4 rounded-md flex flex-col sm:flex-row justify-between gap-5"
              >
                <div className="w-full sm:w-[50%] lg:w-[400px]">
                  {/* Worked Date */}
                  <div className="mb-4">
                    <label className="block text-[14px] font-[500] mb-2">
                      Worked date <span className="text-red-500">*</span>
                    </label>
                    <Controller
                      name="workedDate"
                      control={control}
                      rules={{ required: "Worked date is required" }}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          type="date"
                          fullWidth
                          size="small"
                          error={!!errors.workedDate}
                          helperText={errors.workedDate?.message}
                        />
                      )}
                    />
                  </div>

                  {/* Unit */}
                  <div className="mb-4">
                    <label className="block text-[14px] font-[500] mb-2">
                      Unit <span className="text-red-500">*</span>
                    </label>
                    <Controller
                      name="unit"
                      control={control}
                      rules={{ required: "Unit is required" }}
                      render={({ field }) => (
                        <RadioGroup row {...field}>
                          <FormControlLabel
                            value="Days"
                            control={<Radio />}
                            label="Days"
                          />
                          <FormControlLabel
                            value="Hours"
                            control={<Radio />}
                            label="Hours"
                          />
                        </RadioGroup>
                      )}
                    />
                    {errors.unit && (
                      <p className="text-red-500 text-xs">
                        {errors.unit.message}
                      </p>
                    )}
                  </div>

                  {/* Duration */}
                  <div className="mb-4">
                    <label className="block text-[14px] font-[500] mb-2">
                      Duration <span className="text-red-500">*</span>
                    </label>
                    {unit === "Days" ? (
                      <Controller
                        name="duration"
                        control={control}
                        rules={{ required: "Duration is required" }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={[
                              { value: "Full Day", label: "Full Day" },
                              { value: "Half Day", label: "Half Day" },
                              { value: "Quarter Day", label: "Quarter Day" },
                            ]}
                            isClearable
                             styles={{
                              control: (provided, state) => ({
                                ...provided,
                                backgroundColor: "transparent", // 👈 transparent bg
                                borderColor: state.isFocused
                                  ? "#2684FF"
                                  : provided.borderColor,
                                boxShadow: state.isFocused
                                  ? "0 0 0 1px #2684FF"
                                  : provided.boxShadow,
                              }),
                              menu: (provided) => ({
                                ...provided,
                                backgroundColor: mode === "light" ? "white" : "#141414", 
                              }),
                              option: (provided, state) => ({
                                ...provided,
                                backgroundColor: state.isSelected
                                  ? "#2684FF"
                                  : state.isFocused
                                  ? "#eee"
                                  : "transparent",
                                color: "black",
                              }),
                            }}
                          />
                        )}
                      />
                    ) : (
                      <Controller
                        name="durationTime"
                        control={control}
                        rules={{ required: "Duration time is required" }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            type="text"
                            fullWidth
                            size="small"
                          />
                        )}
                      />
                    )}
                    {errors.duration && (
                      <p className="text-red-500 text-xs">
                        {errors.duration.message}
                      </p>
                    )}
                    {errors.durationTime && (
                      <p className="text-red-500 text-xs">
                        {errors.durationTime.message}
                      </p>
                    )}
                  </div>

                  {/* Worked Time */}
                  {unit === "Hours" && (
                    <div className="mb-4">
                      <label className="block text-[14px] font-[500] mb-2">
                        Worked Time (From - To){" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <div className="flex gap-2">
                        <Controller
                          name="workedTimeFrom"
                          control={control}
                          rules={{ required: "Worked Time From is required" }}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              type="time"
                              fullWidth
                              size="small"
                            />
                          )}
                        />
                        <Controller
                          name="workedTimeTo"
                          control={control}
                          rules={{ required: "Worked Time To is required" }}
                          render={({ field }) => (
                            <TextField
                              {...field}
                              type="time"
                              fullWidth
                              size="small"
                            />
                          )}
                        />
                      </div>
                      {errors.workedTimeFrom && (
                        <p className="text-red-500 text-xs">
                          {errors.workedTimeFrom.message}
                        </p>
                      )}
                      {errors.workedTimeTo && (
                        <p className="text-red-500 text-xs">
                          {errors.workedTimeTo.message}
                        </p>
                      )}
                    </div>
                  )}

                  {/* Expiry Date */}
                  <div className="mb-4">
                    <label className="block text-[14px] font-[500] mb-2">
                      Expiry date <span className="text-red-500">*</span>
                    </label>
                    <Controller
                      name="expiryDate"
                      control={control}
                      rules={{ required: "Expiry date is required" }}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          type="date"
                          fullWidth
                          size="small"
                          error={!!errors.expiryDate}
                          helperText={errors.expiryDate?.message}
                        />
                      )}
                    />
                  </div>

                  {/* Reason */}
                  <div className="mb-4">
                    <label className="block text-[14px] font-[500] mb-2">
                      Reason <span className="text-red-500">*</span>
                    </label>
                    <Controller
                      name="reason"
                      control={control}
                      rules={{ required: "Reason is required" }}
                      render={({ field }) => (
                        <TextField {...field} fullWidth multiline rows={2} />
                      )}
                    />
                    {errors.reason && (
                      <p className="text-red-500 text-xs">
                        {errors.reason.message}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Sticky Footer */}
            <div
              className={`sticky flex gap-3 items-center top-0 ${
                mode === "light" ? "bg-[#edf0f4]" : "bg-[#141414]"
              } z-10 py-4 px-4`}
            >
              <Button
                type="submit"
                variant="contained"
                sx={{ backgroundColor: "#0088ff" }}
              >
                {editData ? "Update" : "Submit"}
              </Button>
              <button
                style={{
                  backgroundColor: mode === "light" ? "#fff" : "#0088ff",
                }}
                className="w-[79px] h-[36px] rounded-md"
                onClick={() => setDrawerOpen(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </form>
      </Drawer>
    );
  };

  const handleDelete = async () => {
    try {
      if (selectedIds.length > 0) {
        await axios.delete("/hr/adminCompensatory/all", {
          data: { selectedIds },
        });

        // Remove deleted requests from state
        setRequests((prev) =>
          prev.filter((req) => !selectedIds.includes(req._id))
        );

        // Reset
        setDeleteModal(false);
        setSelectedIds([]);
        fetchRequests();
      }
    } catch (error) {
      console.error("Error deleting compensatory requests:", error);
      alert("Failed to delete some requests.");
    }
  };

  const ViewModal = ({
    open,
    data,
    onClose,
    onEdit,
    setModalOpen,
    setIsCancelling,
    isCancelling,
    fetchRequests,
  }) => {
    const handleCancel = async () => {
      try {
        setIsCancelling(true);
        await axios.put(`/hr/adminCompensatory/${data._id}/cancel`);
        toast.success("Request cancelled successfully!");

        await fetchRequests(); // 👈 Refetch updated list

        setModalOpen(false);
      } catch (err) {
        console.error("Cancel error:", err);
        toast.error("Failed to cancel request");
      } finally {
        setIsCancelling(false);
      }
    };

    const formatTimeRange = (from, to) => {
      const f = new Date(`1970-01-01T${from}:00Z`);
      const t = new Date(`1970-01-01T${to}:00Z`);
      return `${f.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      })} - ${t.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      })}`;
    };

    return (
      <Drawer
        PaperProps={{
          className:
            "w-[99%] m-1 md:w-[650px] lg:w-[800px] rounded-lg relative",
        }}
        anchor="right"
        open={open}
        onClose={onClose}
      >
        <div className="h-full  flex flex-col relative">
          <div
            className={`${
              mode === "light" ? "bg-[#edf0f4]" : "bg-[#141414]"
            }  px-4 py-2 flex justify-between items-center sticky top-0 z-10`}
          >
            <h4 variant="h4">Compensatory </h4>
            <div className="flex gap-2 items-center">
              {/* {data?.isAllowable !== false && ( */}
              <div
                onClick={onEdit}
                className={`p-2 rounded-md ${
                  mode === "light" ? "bg-[#fff]" : "bg-[#141414]"
                } cursor-pointer`}
              >
                <MdEdit />
              </div>
              {/* )} */}

              <div
                onClick={() => setModalOpen(false)}
                className={`p-2 rounded-md ${
                  mode === "light" ? "bg-[#DCDCDC]" : "bg-[#141414]"
                } cursor-pointer`}
              >
                <IoCloseSharp />
              </div>
            </div>
          </div>

          <div
            className={`${
              mode === "light" ? "bg-[#edf0f4]" : "bg-[#141414]"
            } flex-1 overflow-y-auto p-4`}
          >
            <div
              className="p-4 rounded-md"
              style={{
                backgroundColor: mode === "light" ? "#fff" : "#171717",
              }}
            >
              <p className="flex flex-col mb-[20px] text-sm">
                <p>Employee name:</p>
                {data?.adminName}
              </p>
              <p className="flex flex-col mb-[20px] text-sm">
                <p>Worked date:</p> {getDate(data?.workedDate)}
              </p>
              <p className="flex flex-col mb-[20px] text-sm">
                <p>Duration:</p> {data?.duration}{" "}
                {!["Full Day", "Half Day", "Quarter Day"].includes(
                  data?.duration
                )
                  ? "hour(s)"
                  : ""}
              </p>
              {data?.workedTime?.from && data?.workedTime?.to && (
                <p className="flex flex-col mb-[20px] text-sm">
                  <span>Worked time:</span>{" "}
                  {formatTimeRange(
                    data?.workedTime?.from,
                    data?.workedTime?.to
                  )}
                </p>
              )}

              <p className="flex flex-col mb-[20px] text-sm">
                <p>Credited:</p>{" "}
                {!["Full Day", "Half Day", "Quarter Day"].includes(
                  data?.duration
                )
                  ? data?.duration
                  : data?.duration}
              </p>
              <p className="flex flex-col mb-[20px] text-sm">
                <p>Expiry date:</p> {getDate(data?.expiryDate)}
              </p>
              <p className="flex flex-col mb-[20px] text-sm">
                <p>Reason:</p> {data?.reason}
              </p>
            </div>
          </div>

          <div
            className={`sticky flex gap-3 items-center top-0 ${
              mode === "light" ? "bg-[#edf0f4]" : "bg-[#141414]"
            }  z-10 py-4 px-4`}
          >
            <button
              className="rounded-md w-[67px] h-[31px] text-sm"
              onClick={() => setModalOpen(false)}
              style={{
                border: "1px solid #ededed",
                color: mode === "light" ? "#000" : "#fff",
                background: mode === "light" ? "#fff" : "#141414",
              }}
            >
              Close
            </button>
            <button
              className="rounded-md w-[126px] h-[31px] text-sm"
              type="button"
              onClick={handleCancel}
              disabled={isCancelling || data?.isAllowable === false}
              style={{
                border: "1px solid #f07c81",
                color: "#f07c81",
                background: mode === "light" ? "#fff" : "#141414",
                opacity: isCancelling || data?.isAllowable === false ? 0.6 : 1,
                cursor:
                  isCancelling || data?.isAllowable === false
                    ? "not-allowed"
                    : "pointer",
              }}
            >
              {isCancelling ? "Cancel Record" : "Cancelled Record"}
            </button>
          </div>
        </div>
      </Drawer>
    );
  };

  const formatCompensatoryExportData = (data) => {
    console.log("🚀 ~ formatCompensatoryExportData ~ data:", data);

    const formatDate = (dateStr) => {
      const date = new Date(dateStr);
      return isNaN(date.getTime())
        ? "N/A"
        : date
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })
            .replace(/ /g, "-");
    };

    return data?.map((item) => {
      return {
        adminName: item.adminName || "-",
        adminId: item.adminId || "-",
        submittedBy: item.submittedBy || "-",
        Reason: item.reason || "-",
        Unit: item.unit || "-",
        Duration: item.duration || "-",
        Credited: item?.credited ?? "-",
        Balance: item.balance || "-",
        "Worked Date": formatDate(item?.workedDate),
        "Worked Time From": item?.workedTime?.from || "-",
        "Worked Time To": item?.workedTime?.to || "-",
        "Expiry Date": formatDate(item?.expiryDate),
      };
    });
  };

  const exportData = formatCompensatoryExportData(filteredRequests);

  let currentUser = JSON.parse(localStorage.getItem("user"));
  return (
    <div
      className={`relative h-screen ${
        mode === "light" ? "bg-[#f7f9fc]" : "bg-[#141414]"
      }`}
    >
      <div className="flex justify-end items-center gap-2">
        <div>
          <Box className="flex">
            <button
              onClick={() => setView("direct")}
              className={`px-4 py-1 rounded-[4px] text-[14px] ${
                view === "direct"
                  ? `${
                      mode === "light" ? "bg-white" : "bg-transparent"
                    }  border border-blue-500`
                  : ` ${
                      mode === "light"
                        ? "bg-gray-200 text-black"
                        : "bg-transparent text-white"
                    } `
              }`}
            >
              Direct
            </button>
            <button
              onClick={() => setView("all")}
              className={`px-4 py-1 rounded-[4px] text-[14px] ${
                view === "all"
                  ? `${
                      mode === "light" ? "bg-white" : "bg-transparent"
                    }  border border-blue-500`
                  : ` ${
                      mode === "light"
                        ? "bg-gray-200 text-black"
                        : "bg-transparent text-white"
                    } `
              }`}
            >
              All
            </button>
          </Box>
        </div>

        <div>
          <button
            className="w-[120px] h-[32px] bg-[#0088FF] rounded-md text-white text-[14px]"
            onClick={() => {
              setEditData(null);
              setDrawerOpen(true);
            }}
          >
            Add Request
          </button>
        </div>

        <div
          className={`relative group p-2 rounded-md cursor-pointer ${
            mode === "light" ? "bg-[#fff]" : ""
          }`}
        >
          <IoFilterOutline
            size={17}
            className="cursor-pointer"
            onClick={() => setOpenFilterDrawer(true)}
          />
          <span className="absolute left-1/2 -translate-x-1/2 text-xs w-[max-content] bg-gray-800 text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition">
            Filter
          </span>
        </div>

        <div
          className={`relative group p-2 rounded-md ${
            mode === "light" ? "bg-[#fff]" : ""
          }`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <IoIosMore size={17} className="cursor-pointer" />
          {isOpen && (
            <Box
              sx={{ backgroundColor: mode === "light" ? "#fff" : "#363636" }}
              className="absolute w-[150px] z-40 right-3 shadow-md p-5 flex flex-col gap-2 rounded-lg top-10"
            >
              <div
                onClick={() => setOpenImportModal(true)}
                className="flex gap-2 items-center cursor-pointer"
              >
                <CiImport size={18} />
                <p className="text-[14px]">Import</p>
              </div>
              <div
                onClick={() => setExportOpen(true)}
                className="flex gap-2 items-center cursor-pointer"
              >
                <CiExport size={18} />
                <p className="text-[14px]">Export</p>
              </div>
            </Box>
          )}
          <span className="absolute left-1/2 -translate-x-1/2 w-[max-content] text-xs bg-gray-800 text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition">
            More
          </span>
        </div>
      </div>

      {selectedIds.length > 0 && (
        <div
          onClick={() => setDeleteModal(true)}
          className="flex justify-start mb-2 w-[70px] h-[31px]"
        >
          <button className="bg-red-500 text-white px-4 py-1 rounded">
            Delete
          </button>
        </div>
      )}

      {currentOrg?.type === "Owner" &&
        (filteredRequests?.length > 0 ? (
          <TableContainer className="rounded-md overflow-x-auto h-[full] mt-[20px]">
            <Table>
              <TableHead>
                <TableRow
                  className={`${
                    mode === "light" ? "bg-[#e7e9f3]" : "bg-transparent"
                  }`}
                >
                  <TableCell padding="checkbox">
                    <Checkbox
                      size="small"
                      checked={
                        requests?.length > 0 &&
                        selectedIds?.length === requests?.length
                      }
                      indeterminate={
                        selectedIds?.length > 0 &&
                        selectedIds?.length < requests?.length
                      }
                      onChange={(e) => {
                        e.stopPropagation();
                        handleSelectAll(e.target.checked);
                        setModalOpen(false);
                      }}
                    />
                  </TableCell>
                  {view !== "direct" && (
                    <TableCell className="font-medium text-xs text-[#4a4a4a]">
                      Reporting to
                    </TableCell>
                  )}
                  <TableCell className="font-medium text-xs text-[#4a4a4a]">
                    Worked date
                  </TableCell>
                  <TableCell className="font-medium text-xs text-[#4a4a4a]">
                    Expiry date
                  </TableCell>
                  <TableCell className="font-medium text-xs text-[#4a4a4a]">
                    Status
                  </TableCell>
                  <TableCell className="font-medium text-xs text-[#4a4a4a]">
                    Credited
                  </TableCell>
                  <TableCell className="font-medium text-xs text-[#4a4a4a]">
                    Taken
                  </TableCell>
                  <TableCell className="font-medium text-xs text-[#4a4a4a]">
                    Balance
                  </TableCell>
                  <TableCell className="font-medium text-xs text-[#4a4a4a]">
                    Reason
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredRequests.map((req) => (
                  <TableRow key={req._id} className="cursor-pointer">
                    <TableCell
                      padding="checkbox"
                      onClick={() => {
                        setEditData(req);
                        setModalOpen(true);
                      }}
                    >
                      <Checkbox
                        size="small"
                        checked={selectedIds.includes(req._id)}
                        onChange={(e) => {
                          e.stopPropagation();
                          handleCheckboxChange(req._id, e.target.checked);
                          setModalOpen(false);
                        }}
                      />
                    </TableCell>
                    {view !== "direct" && (
                      <TableCell
                        onClick={() => {
                          setEditData(req);
                          setModalOpen(true);
                        }}
                        className="text-sm text-[#141414]"
                      >
                        {currentUser?.firstName} {currentUser?.lastName}
                      </TableCell>
                    )}
                    <TableCell
                      onClick={() => {
                        setEditData(req);
                        setModalOpen(true);
                      }}
                      className="text-sm text-[#141414]"
                    >
                      {getDate(req?.workedDate)}
                    </TableCell>
                    <TableCell
                      onClick={() => {
                        setEditData(req);
                        setModalOpen(true);
                      }}
                      className="text-sm text-[#141414]"
                    >
                      {getDate(req?.expiryDate)}
                    </TableCell>
                    <TableCell className="text-sm text-[#141414]">
                      {req?.isAllowable === false ? (
                        <span className="text-sm  ">Cancelled</span>
                      ) : (
                        <Button
                          onClick={() => setOpenApply(true)}
                          variant="outlined"
                          size="small"
                          sx={{
                            fontSize: "11px",
                            textTransform: "none",
                            color: "#0088ff",
                            borderColor: "#0088ff",
                            padding: "2px 8px",
                            borderRadius: "6px",
                          }}
                        >
                          Book Comp off
                        </Button>
                      )}
                    </TableCell>
                    <TableCell
                      onClick={() => {
                        setEditData(req);
                        setModalOpen(true);
                      }}
                      className="text-sm text-[#141414]"
                    >
                      {req?.duration &&
                      !["Full Day", "Half Day", "Quarter Day"].includes(
                        req?.duration
                      ) ? (
                        <>
                          {req?.duration}{" "}
                          <span className="text-xs ">hour(s)</span>
                        </>
                      ) : (
                        <span className="text-xs ">{req?.duration}</span>
                      )}
                    </TableCell>
                    <TableCell
                      onClick={() => {
                        setEditData(req);
                        setModalOpen(true);
                      }}
                      className="text-sm text-[#141414]"
                    >
                      {req?.taken &&
                      !["Full Day", "Half Day", "Quarter Day"].includes(
                        req?.taken
                      ) ? (
                        <>
                          {req?.taken} <span className="text-xs ">hour(s)</span>
                        </>
                      ) : (
                        <span className="text-xs ">{req?.taken}</span>
                      )}
                    </TableCell>
                    <TableCell
                      onClick={() => {
                        setEditData(req);
                        setModalOpen(true);
                      }}
                      className="text-sm text-[#141414]"
                    >
                      {req?.balance &&
                      !["Full Day", "Half Day", "Quarter Day"].includes(
                        req?.balance
                      ) ? (
                        <>
                          {req?.balance}{" "}
                          <span className="text-xs ">hour(s)</span>
                        </>
                      ) : (
                        <span className="text-xs ">{req?.balance}</span>
                      )}
                    </TableCell>
                    <TableCell
                      onClick={() => {
                        setEditData(req);
                        setModalOpen(true);
                      }}
                      className="text-sm text-[#141414]"
                    >
                      {req?.reason}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <NocompensatoryRequest />
        ))}

      {currentOrg?.type === "Member" &&
        (filteredRequests?.length > 0 ? (
          <TableContainer className="rounded-md overflow-x-auto h-[full] mt-[20px]">
            <Table>
              <TableHead>
                <TableRow
                  className={`${
                    mode === "light" ? "bg-[#e7e9f3]" : "bg-transparent"
                  }`}
                >
                  <TableCell padding="checkbox">
                    <Checkbox
                      size="small"
                      checked={
                        requests?.length > 0 &&
                        selectedIds?.length === requests?.length
                      }
                      indeterminate={
                        selectedIds?.length > 0 &&
                        selectedIds?.length < requests?.length
                      }
                      onChange={(e) => {
                        e.stopPropagation();
                        handleSelectAll(e.target.checked);
                        setModalOpen(false);
                      }}
                    />
                  </TableCell>
                  <TableCell className="font-medium text-xs text-[#4a4a4a]">
                    Name
                  </TableCell>
                  {view !== "direct" && (
                    <TableCell className="font-medium text-xs text-[#4a4a4a]">
                      Reporting to
                    </TableCell>
                  )}
                  <TableCell className="font-medium text-xs text-[#4a4a4a]">
                    Worked date
                  </TableCell>
                  <TableCell className="font-medium text-xs text-[#4a4a4a]">
                    Expiry date
                  </TableCell>
                  <TableCell className="font-medium text-xs text-[#4a4a4a]">
                    Status
                  </TableCell>
                  <TableCell className="font-medium text-xs text-[#4a4a4a]">
                    Credited
                  </TableCell>
                  <TableCell className="font-medium text-xs text-[#4a4a4a]">
                    Taken
                  </TableCell>
                  <TableCell className="font-medium text-xs text-[#4a4a4a]">
                    Balance
                  </TableCell>
                  <TableCell className="font-medium text-xs text-[#4a4a4a]">
                    Reason
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredRequests.map((req) => (
                  <TableRow key={req._id} className="cursor-pointer">
                    <TableCell
                      padding="checkbox"
                      onClick={() => {
                        setEditData(req);
                        setModalOpen(true);
                      }}
                    >
                      <Checkbox
                        size="small"
                        checked={selectedIds.includes(req._id)}
                        onChange={(e) => {
                          e.stopPropagation();
                          handleCheckboxChange(req._id, e.target.checked);
                          setModalOpen(false);
                        }}
                      />
                    </TableCell>
                    <TableCell className="text-sm text-[#141414]">
                      <span>
                        {req?.employee?.firstName} {req?.employee?.lastName}
                      </span>
                    </TableCell>
                    {view !== "direct" && (
                      <TableCell
                        onClick={() => {
                          setEditData(req);
                          setModalOpen(true);
                        }}
                        className="text-sm text-[#141414]"
                      >
                        {currentUser?.firstName} {currentUser?.lastName}
                      </TableCell>
                    )}
                    <TableCell
                      onClick={() => {
                        setEditData(req);
                        setModalOpen(true);
                      }}
                      className="text-sm text-[#141414]"
                    >
                      {getDate(req?.workedDate)}
                    </TableCell>
                    <TableCell
                      onClick={() => {
                        setEditData(req);
                        setModalOpen(true);
                      }}
                      className="text-sm text-[#141414]"
                    >
                      {getDate(req?.expiryDate)}
                    </TableCell>
                    <TableCell className="text-sm text-[#141414]">
                      {req?.isAllowable === false ? (
                        <span className="text-sm  ">Cancelled</span>
                      ) : (
                        <Button
                          onClick={() => setOpenApply(true)}
                          variant="outlined"
                          size="small"
                          sx={{
                            fontSize: "11px",
                            textTransform: "none",
                            color: "#0088ff",
                            borderColor: "#0088ff",
                            padding: "2px 8px",
                            borderRadius: "6px",
                          }}
                        >
                          Book Comp off
                        </Button>
                      )}
                    </TableCell>
                    <TableCell
                      onClick={() => {
                        setEditData(req);
                        setModalOpen(true);
                      }}
                      className="text-sm text-[#141414]"
                    >
                      {req?.duration &&
                      !["Full Day", "Half Day", "Quarter Day"].includes(
                        req?.duration
                      ) ? (
                        <>
                          {req?.duration}{" "}
                          <span className="text-xs ">hour(s)</span>
                        </>
                      ) : (
                        <span className="text-xs ">{req?.duration}</span>
                      )}
                    </TableCell>
                    <TableCell
                      onClick={() => {
                        setEditData(req);
                        setModalOpen(true);
                      }}
                      className="text-sm text-[#141414]"
                    >
                      {req?.taken &&
                      !["Full Day", "Half Day", "Quarter Day"].includes(
                        req?.taken
                      ) ? (
                        <>
                          {req?.taken} <span className="text-xs ">hour(s)</span>
                        </>
                      ) : (
                        <span className="text-xs ">{req?.taken}</span>
                      )}
                    </TableCell>
                    <TableCell
                      onClick={() => {
                        setEditData(req);
                        setModalOpen(true);
                      }}
                      className="text-sm text-[#141414]"
                    >
                      {req?.balance &&
                      !["Full Day", "Half Day", "Quarter Day"].includes(
                        req?.balance
                      ) ? (
                        <>
                          {req?.balance}{" "}
                          <span className="text-xs ">hour(s)</span>
                        </>
                      ) : (
                        <span className="text-xs ">{req?.balance}</span>
                      )}
                    </TableCell>
                    <TableCell
                      onClick={() => {
                        setEditData(req);
                        setModalOpen(true);
                      }}
                      className="text-sm text-[#141414]"
                    >
                      {req?.reason}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <NocompensatoryRequest />
        ))}

      <div
        className={`fixed bottom-0 left-[100px] right-[180px] w-full ${
          mode === "light" ? "bg-[#f7f9fc]" : "bg-[#141414]"
        }  p-3 flex items-center justify-between text-sm`}
      >
        <div className="text-gray-700">
          Total Record Count :{" "}
          <span className="text-blue-500">{requests?.length}</span>
        </div>

        <div className="flex items-center gap-3 me-[100px]">
          <select
            className={` ${
              mode === "light" ? "bg-white" : "bg-transparent"
            } border border-gray-300 rounded px-2 py-1`}
            value={recordsPerPage}
            onChange={(e) => setRecordsPerPage(Number(e.target.value))}
          >
            {[20, 50, 75, 100, 200].map((num) => (
              <option
                className={
                  mode === "light"
                    ? "bg-white text-black"
                    : "bg-black text-white"
                }
                key={num}
                value={num}
              >
                {num}
              </option>
            ))}
          </select>
          <span className="text-gray-600">Records per page</span>

          <div className="flex items-center gap-2">
            <button className="px-2 py-1 border rounded text-gray-500 cursor-not-allowed">
              &lt;
            </button>
            <span className="text-gray-700">1 - {requests?.length}</span>
            <button className="px-2 py-1 border rounded text-gray-500 cursor-not-allowed">
              &gt;
            </button>
          </div>
        </div>
      </div>

      <FilterDrawer filterr={filterr} setFilterr={setFilterr} />
      <AddRequestDrawer
        editData={editData}
        showError={showError}
        showSuccess={showSuccess}
      />

      <Dialog open={deleteModal} onClose={() => setDeleteModal(false)}>
        <DialogTitle sx={{ textAlign: "center", position: "relative" }}>
          <ErrorOutlineIcon sx={{ color: "red", fontSize: 40, mb: 1 }} />
          <div>Delete leave?</div>
          <IconButton
            aria-label="close"
            onClick={() => setDeleteModal(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CgClose />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ textAlign: "center" }}>
            This action will delete all data of this Leave and it cannot be
            retrieved
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
          <Button
            variant="contained"
            color="error"
            // onClick={onConfirm}
            sx={{ textTransform: "none", px: 4 }}
            onClick={handleDelete}
          >
            Confirm
          </Button>
          <Button
            variant="outlined"
            onClick={() => setDeleteModal(false)}
            sx={{ textTransform: "none", px: 4 }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <ApplyLeaveModal openApply={openApply} setOpenApply={setOpenApply} />

      <ExportModal
        open={exportOpen}
        handleClose={() => setExportOpen(false)}
        tableData={exportData}
      />

      <ImportModal
        open={openImportModal}
        handleDone={handleCompensatoryImport}
        selectedFile={selectedFile}
        setSelectedFile={setSelectedFile}
        handleClose={handleClose}
      />

      <ViewModal
        open={modalOpen}
        data={editData}
        setModalOpen={setModalOpen}
        onClose={() => setModalOpen(false)}
        onEdit={() => {
          setEditData(editData);
          setModalOpen(false); // Close modal
          setDrawerOpen(true); // Open drawer
        }}
        setIsCancelling={setIsCancelling}
        isCancelling={isCancelling}
        fetchRequests={fetchRequests}
      />
    </div>
  );
}
